import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { DatatableComponent, TableColumn } from '@swimlane/ngx-datatable';
import { BsModalService } from 'ngx-bootstrap';
import { first } from 'rxjs/operators';
import { CampoSolicitud } from '../../../core/model/campo-solicitud';
import { ContadorContenidos, ContenidoSolicitud, DetalleSolicitud, FiltrosContenidos, TableContentInfo, TableInfo } from '../../../core/model/detalle-solicitud';
import { FechaContenedor } from '../../../core/model/inventories';
import { IPagination } from '../../../core/model/pagination';
import { ResizedEvent } from '../../../core/model/resized-event';
import { SolicitudMaterial } from '../../../core/model/solicitud-materiales';
import { TemplateField } from '../../../core/model/template-field';
import { DetalleService } from '../../../core/services/Detalle/detalle.service';
import { InventariosService } from '../../../core/services/inventarios.service';
import { ModalShowTextComponent } from '../../../utils/modal-show-text/modal-show-text.component';
import { AuthenticationService } from '../../../core/services/authentication.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-tabla-contenidos',
  templateUrl: './tabla-contenidos.component.html',
  styleUrls: ['./tabla-contenidos.component.css']
})
export class TablaContenidosComponent implements OnInit {

  @ViewChild('tblcontent') tablaNormalElementRef: DatatableComponent;
  @ViewChild('tblContainerContent') tablaContainerElementRef: DatatableComponent;
  @ViewChild('tblRecordContent') tablaRecordElementRef: DatatableComponent;
  @ViewChild('tblAzContent') tablaAzElementRef: DatatableComponent;


  @Input() set massiveEntryDate(entryDate: Date) {
    if (entryDate) {
      this.setDateInTableInfo(this.normalTable, entryDate, 'fechaEntrada');
      this.setDateInTableInfo(this.recordTable, entryDate, 'fechaEntrada');
      this.setDateInTableInfo(this.containerTable, entryDate, 'fechaEntrada');
      this.setDateInTableInfo(this.azTable, entryDate, 'fechaEntrada');
    }
  }

  @Input() set massiveRealEndDate(realEndDate: Date) {
    if (realEndDate) {
      this.setDateInTableInfo(this.normalTable, realEndDate, 'fechaRealFin');
      this.setDateInTableInfo(this.recordTable, realEndDate, 'fechaRealFin');
      this.setDateInTableInfo(this.containerTable, realEndDate, 'fechaRealFin');
      this.setDateInTableInfo(this.azTable, realEndDate, 'fechaRealFin');
    }
  }

  @Input() set isMaterialRequest(isMaterialRequest: boolean) {
    this._isMaterialsRequest = isMaterialRequest;
    this.getContents();
  }
  get isMaterialRequest(): boolean {
    return this._isMaterialsRequest;
  }

  @Input() set contadorContenidos(contador: ContadorContenidos) {
    this.resetInitialData();
    this.contador = contador;
    this.getContents();
  }

  idSolicitudDevolucion: number;
  @Input() set solicitudDevolucionId(solicitudDevolucionId: number) {
    this.resetInitialData();
    this.idSolicitudDevolucion = solicitudDevolucionId;
    this.getContents();
  }

  @Input() set idSolicitud(solicitudId: number) {
    this.solicitudId = solicitudId;
    this.getContents();
  }

  @Input() contenidoIdSelected: number | undefined = undefined;
  @Input() contenidoSeleccionado: number;

  @Input() isDevoluciones = false;
  @Input() filtroDevolucion = null;

  @Output() selectEvent = new EventEmitter<TableContentInfo>();
  @Output() hasMoreThanOneTableEvent = new EventEmitter<boolean>(false);
  @Output() hasAllData = new EventEmitter<boolean>(false);

  @Output() setContenidosNoInventariados = new EventEmitter<TableContentInfo[]>();
  @Output() setContenidosExpedientes = new EventEmitter<TableContentInfo[]>();
  @Output() setContenidosContenedores = new EventEmitter<TableContentInfo[]>();
  @Output() setContenidosAZs = new EventEmitter<TableContentInfo[]>();

  @Output() resetRowSelect = new EventEmitter<boolean>();


  @Input() set setExpirationDate(expirationDate: Date) {
    if (expirationDate) {
      const rowSelected: TableContentInfo[] = this.getRowSelected();
      if (rowSelected) {
        rowSelected[0].fechaExpiracion = expirationDate;
      }
    }
  }

  nombreTipoServicio: string;
  @Input() set nombreServicio(nombreServicio: string) {
    this.nombreTipoServicio = nombreServicio;
    this.getContents();
  }

  @Input() set idSerie(idSerie: number) {
    this._idSerie = idSerie;
    this.getContents();
  }
  get idSerie(): number {
    return this._idSerie;
  }
  private _idSerie: number;

  @Input() clienteId: number;

  @Input() rowsDevolucionesSelected: TableContentInfo[] = [];
  @Output() rowsDevolucionesSelectedChange = new EventEmitter<TableContentInfo[]>();

  //🥑🥑 SRR paso todos los valores de la solicitud para mostrarlo en el excel
  @Input() viewDetails: DetalleSolicitud;
  @Input() tienePermisoCambiarProveedores: boolean;

  normalTable: TableInfo;
  recordTable: TableInfo;
  containerTable: TableInfo;
  azTable: TableInfo;

  hasMoreThanOneTable = false;
  hasData = false;
  contador: ContadorContenidos;
  solicitudId: number;

  hasNoInventoryData = false;
  hasRecordData = false;
  hasContainerData = false;
  hasAzData = false;
  hasMaterials = false;

  containerFiltersField: TemplateField[];

  _isMaterialsRequest: boolean;

  filtroNormalContent: FiltrosContenidos;
  filtroExpedienteContent: FiltrosContenidos;
  filtroContenedoresContent: FiltrosContenidos;
  filtroAZContent: FiltrosContenidos;

  isNormalTableSearch = false;
  isNormalTableFiltered = false;
  isNormalTableChangingPage = true;

  isContainerTableChangingPage = true;
  isContainerTableFiltered = false;

  isRecordTableChangingPage = true;
  isRecordTableFiltered = false;

  isAzTableFiltered = false;
  isAzTableChangingPage = false;


  hasRequestedInitialData = false;

  normalTableDatasToExport: any[];
  containerTableDatasToExport: any[];
  recordTableDatasToExport: any[];
  azTableDatasToExport: any[];

  isdocout = false;
  isAdmin = false;
  totalContentCounter = 0;

  recordValuesColumns = [
    { name: 'Id', prop: 'ID' },
    { name: this.translateService.instant('solicitudes.columns.Name'), prop: 'NAME' },
    { name: this.translateService.instant('solicitudes.columns.Value'), prop: 'VALUE' }
  ];

  constructor(private translateService: TranslateService,
    private router: Router,
    private inventoryService: InventariosService,
    private modalService: BsModalService,
    private detalleservice: DetalleService,
    private authService: AuthenticationService,
    private toastr: ToastrService
  ) { }

  ngOnInit() {
    this.authService.isDocOutUser().then((r: boolean) => this.isdocout = r).catch((r: Error) => this.isdocout = false);
    this.isAdmin = this.authService.isAdminUser();
  }

  canRollbackContents(): boolean {
    return this.isdocout && this.authService.isAdmin;
  }

  private resetAllTables(): any {
    this.normalTable = undefined;
    this.recordTable = undefined;
    this.containerTable = undefined;
    this.azTable = undefined;
  }

  private resetInitialData() {
    this.hasRequestedInitialData = false;
    this.hasNoInventoryData = false;
    this.hasContainerData = false;
    this.hasRecordData = false;
    this.hasAzData = false;
    this.resetAllTables();
  }

  private hasContents(contents: ContenidoSolicitud[]): any {
    return contents && contents.length > 0;
  }

  private thereAreMoreOneTable(): boolean {
    return Number(!!this.normalTable) + Number(!!this.recordTable) + Number(!!this.containerTable) > 1;
  }

  private getRecordDatatableContent(recordContents: IPagination<ContenidoSolicitud>): TableInfo {
    let recordTable = this.getDatatableGeneralContent(recordContents.dataList, this.recordTable);
    recordTable = this.getRecordValues(recordContents, recordTable);
    recordTable.page.totalElements = recordContents.totalResults;
    return recordTable;
  }

  private getAzDatatableContent(azContents: IPagination<ContenidoSolicitud>): TableInfo {
    const azTable = this.getDatatableGeneralContent(azContents.dataList, this.azTable);

    azTable.columnsCampos = [];

    if (azTable.rows && azTable.rows.length) {
      azTable.columnsCampos = (azTable.rows && azTable.rows.length > 0) ? Object.keys((<TableContentInfo>azTable.rows[0]).campos)
        .map(campo => ({ name: campo, prop: campo })) : [];
      this.containerFiltersField = this.getFiltersFields('az');
    }
    azTable.page.totalElements = azContents.totalResults;
    return azTable;
  }

  private getRecordValues(recordContents: IPagination<ContenidoSolicitud>, recordTable: TableInfo): TableInfo {
    let recordValues: { NAME: string, PRINCIPAL: boolean, VALUE: string, ID: number }[] = [];

    recordContents.dataList.forEach((recordContent: ContenidoSolicitud) => {
      const rows = recordTable.rows as TableContentInfo[];
      const rowSelected = rows.find((row: TableContentInfo) => row.contenidoId == recordContent.ID_CONTENIDO);
      recordContent.Campos.forEach(campo => recordValues.push(campo));
      rowSelected.valoresExpediente = recordValues;
      recordValues = [];
    });

    return recordTable;
  }

  private getRowSelected(): TableContentInfo[] {
    if (this.hasSingleSelected(this.normalTable)) {
      return this.normalTable.singleSelected;
    }
    if (this.hasSingleSelected(this.recordTable)) {
      return this.recordTable.singleSelected;
    }
    if (this.hasSingleSelected(this.containerTable)) {
      return this.containerTable.singleSelected;
    }
    if (this.hasSingleSelected(this.azTable)) {
      return this.azTable.singleSelected;
    }
  }

  private hasSingleSelected(tableInfo: TableInfo) {
    return tableInfo && tableInfo.singleSelected && tableInfo.singleSelected.length > 0;
  }

  private getNormalDatatableContent(normalContents: IPagination<ContenidoSolicitud>, table: TableInfo): TableInfo {
    let normalTable = this.getDatatableGeneralContent(normalContents.dataList, table);
    if (this.hasContents(normalContents.dataList)) {
      const multivalueFields = this.getFieldsMultivalue(normalContents.dataList);
      normalTable = this.getNormalDataFieldContent(multivalueFields, normalContents.dataList[0].Campos, normalTable);
    }
    normalTable.page.totalElements = normalContents.totalResults;
    return normalTable;
  }

  private getContainerDatatableContent(containerContents: IPagination<ContenidoSolicitud>, table: TableInfo): TableInfo {
    const containerTable = this.getDatatableGeneralContent(containerContents.dataList, table);
    containerTable.columnsCampos = [];

    if (containerTable.rows && containerTable.rows.length) {
      const firstRow = containerTable.rows[0] as TableContentInfo;

      containerTable.columnsCampos = Object.keys(firstRow.campos).map(nameCampo => ({ name: nameCampo, prop: nameCampo }));
      this.containerFiltersField = this.getFiltersFields('contenedor');
    }

    containerTable.page.totalElements = containerContents.totalResults;
    return containerTable;
  }
  private getFiltersFields(tipo: string): TemplateField[] {
    const campos = [];

    if (tipo === 'contenedor') {
      const containerNumberField = new TemplateField();
      containerNumberField.id = 1;
      containerNumberField.tipo = 'NUMERIC';
      containerNumberField.nombre = 'NUM_CONTENEDOR';
      containerNumberField.max = 20;
      containerNumberField.descripcion = this.translateService.instant('vistadetalle.NUM_CONTENEDOR');

      const alienContainerField = new TemplateField();
      alienContainerField.id = 2;
      alienContainerField.tipo = 'STRING';
      alienContainerField.nombre = 'CONTENEDOR_AJENO';
      alienContainerField.max = 20;
      alienContainerField.descripcion = this.translateService.instant('vistadetalle.CONTENEDOR_AJENO');

      const entryDateContainerField = new TemplateField();
      entryDateContainerField.id = 3;
      entryDateContainerField.tipo = 'DATE';
      entryDateContainerField.nombre = 'ENTRY_DATE_CONTAINER';
      entryDateContainerField.descripcion = this.translateService.instant('vistadetalle.ENTRY_DATE_CONTAINER');
      entryDateContainerField.value = [new FechaContenedor()];

      campos.push(containerNumberField);
      campos.push(alienContainerField);
      campos.push(entryDateContainerField);
    }

    if (tipo === 'az') {
      const containerIdField = new TemplateField();
      containerIdField.id = 1;
      containerIdField.tipo = 'NUMERIC';
      containerIdField.nombre = 'ID_CONTENEDOR';
      containerIdField.max = 20;
      containerIdField.descripcion = this.translateService.instant('vistadetalle.NUM_CONTENEDOR');

      const azDescriptionField = new TemplateField();
      azDescriptionField.id = 2;
      azDescriptionField.tipo = 'STRING';
      azDescriptionField.nombre = 'DESCRIPCION_AZ';
      azDescriptionField.max = 50;
      azDescriptionField.descripcion = this.translateService.instant('inventory.azFields.DESCRIPCION_AZ');

      campos.push(containerIdField);
      campos.push(azDescriptionField);
    }

    return campos;
  }

  getFieldsMultivalue(normalContents: ContenidoSolicitud[]): any[] {
    const fieldsMultivalues = [];

    normalContents.forEach((normalContent: ContenidoSolicitud) => {
      const sorted_fields = normalContent.Campos.slice().sort();
      for (let i = 0; i < sorted_fields.length - 2; i++) {
        if (sorted_fields[i + 1].NAME == sorted_fields[i].NAME && !this.containsFieldMultivalue(fieldsMultivalues, sorted_fields[i])) {
          fieldsMultivalues.push(sorted_fields[i]);
        }
      }
    });

    return fieldsMultivalues;
  }
  private containsFieldMultivalue(fieldsMultivalues: { NAME: string; PRINCIPAL: boolean; VALUE: string; ID: number; }[],
    field: { NAME: string; PRINCIPAL: boolean; VALUE: string; ID: number; }): boolean {
    return fieldsMultivalues.some(fieldMultivalue => fieldMultivalue.NAME == field.NAME);
  }

  private getNormalDataFieldContent(multivalueFields: any[],
    campos: [{ NAME: string; PRINCIPAL: boolean; VALUE: string; ID: number; }],
    normalTable: TableInfo): TableInfo {
    normalTable.columnsCampos = [];

    campos.reverse().forEach(campo => {
      const isMultivalue = multivalueFields.some(multivalue => multivalue.NAME == campo.NAME);
      if (isMultivalue && !this.isAdded(campo, normalTable.columnsMultivalue)) {
        normalTable.columnsMultivalue.push({ name: campo.NAME, prop: campo.NAME });
      } else if (!isMultivalue) {
        normalTable.columnsCampos.splice(0, 0, { name: campo.NAME, prop: campo.NAME });
      }
    });
    return normalTable;
  }

  private isAdded(campo: { NAME: string; PRINCIPAL: boolean; VALUE: string; ID: number; },
    columnsMultivalue: TableColumn[]): any {
    return columnsMultivalue.find(column => column.name === campo.NAME);
  }


  private getDatatableGeneralContent(contents: ContenidoSolicitud[], table: TableInfo): TableInfo {
    const datas: TableContentInfo[] = [];
    if (!table) {
      table = new TableInfo();
      table.columns = this.getGeneralColumns();
      table.hasColumnRelationRequest = contents.some((content: ContenidoSolicitud) => content.SOLICITUD_RELACIONADA != undefined);
      table.exportColumns = this.hasContents(contents) ? [].concat(this.getDynamicExportColumns(contents[0].Campos), table.columns)
        : [];
    }

    if (this.hasContents(contents)) {
      table.rows = this.getTableRows(contents);
      if (this.isDevolucionSolicitud()) {
        table.singleSelected = [...table.rows as TableContentInfo[]];
        this.rowsDevolucionesSelected = [...table.rows as TableContentInfo[]];
        this.rowsDevolucionesSelectedChange.emit(this.rowsDevolucionesSelected);
      }
    } else {
      table.rows = [];
    }

    if (this.contenidoIdSelected) {
      const elemento = datas.find((tableContentInfo: TableContentInfo) => tableContentInfo.contenidoId == this.contenidoIdSelected);
      table.singleSelected = [];
      table.singleSelected.push(elemento);
      this.selectEvent.emit(table.singleSelected[0]);
    }

    return table;
  }
  private isDevolucionSolicitud(): boolean {
    return !!this.idSolicitudDevolucion;
  }
  private getTableRows(contents: ContenidoSolicitud[]): TableContentInfo[] | SolicitudMaterial[] {
    const datas: TableContentInfo[] = [];
    if (this.hasContents(contents)) {
      contents.forEach((content: ContenidoSolicitud) => {
        const row: TableContentInfo = this.convertContenidoSolicitud(content);
        datas.push(row);
      });

      return datas.sort((a, b) => a.contenidoId < b.contenidoId ? 1 : -1);
    } else {
      return [];
    }
  }
  private getDynamicExportColumns(campos: [{ NAME: string, PRINCIPAL: boolean, VALUE: string, ID: number, DESCRIPCION: string }]): any[] {
    return campos.map(campo => {
      if (campo) {
        return { name: campo.NAME, prop: campo.NAME, isDynamic: true };
      }
    }).filter(campo => campo);
  }

  private getGeneralColumns(): TableColumn[] {

    const columns: TableColumn[] = [];
    columns.push({ name: 'Situation', prop: 'situacionNombre' });
    columns.push({ name: 'State', prop: 'estadoNombre' });

    return columns;
  }

  private convertContenidoSolicitud(content: ContenidoSolicitud): TableContentInfo {
    const row: TableContentInfo = new TableContentInfo();
    row.situacionId = content.Situacion.Id;
    row.situacionNombre = content.Situacion.NOMBRE;
    row.estadoId = content.Estado.Id;
    row.estadoNombre = content.Estado.NOMBRE;
    row.contenidoId = content.ID_CONTENIDO;
    row.fechaExpiracion = content.FECHA_EXPIRACION;
    row.fechaFinalizacion = content.FECHA_FINALIZACION;
    row.fechaInicio = content.FECHA_INICIO;
    row.fechaEntrada = content.FECHA_ENTRADA;
    row.fechaRealFin = content.FECHA_FIN_REAL;
    row.ficheros = content.Ficheros;
    row.isInventario = content.isInventario;
    row.inventarioId = content.ID_EXPEDIENTE_INV;
    row.isParcial = content.isParcial;
    row.obsParcial = content.ObsParcial;
    row.contenidoRelacionado = content.CONTENIDO_RELACIONADO;
    row.solicitudRelacionada = content.SOLICITUD_RELACIONADA;
    row.tipoUnidadDoc = content.TipoUnidadDoc;
    row.idContenedor = content.ID_CONTENEDOR;
    row.numContenedor = content.NUMERO_CONTENEDOR;
    // 🥑🥑 PROVEEDOR
    row.proveedor = content.PROVEEDOR === null ? 'Docout' : content.PROVEEDOR.NOMBRE;
    row.idProveedor = content.PROVEEDOR === null ? null : content.PROVEEDOR.Id;
    row.correoProveedor = content.PROVEEDOR === null ? 'Docout@docout.es' : content.PROVEEDOR.EMAIL_SOPORTE;
    row.telefonoProveedor = content.PROVEEDOR === null ? '666666666' : content.PROVEEDOR.TELEFONO;
    row.contactoProveedor = content.PROVEEDOR === null ? 'Contacto Docout' : content.PROVEEDOR.NOMBRE_CONTACTO;
    row.expirado = !!content.FECHA_EXPIRACION ? new Date(content.FECHA_EXPIRACION) < new Date()
      : false;
    content.Campos.forEach(campo => {
      row.campos[campo.NAME] = (!row.campos[campo.NAME]) ? campo.VALUE : [row.campos[campo.NAME], campo.VALUE];
    });

    row.campos = this.convertCamposToDate(row.campos);

    return row;
  }

  private convertCamposToDate(campos): any {
    const camposCorrectos = {};
    Object.keys(campos).forEach(nombreCampo => {
      if (campos[nombreCampo] instanceof Array) {
        const value = this.formatSameValue(campos[nombreCampo]);
        camposCorrectos[nombreCampo] = value;
      } else {
        camposCorrectos[nombreCampo] = this.formatValue(campos[nombreCampo]);
      }
    });

    return camposCorrectos;
  }

  private formatSameValue(value: any[]): any {
    const allValuesAreDates = !value.some(val => !this.isFormatIsoDate(val));
    if (allValuesAreDates) {
      const valuesDatesOrdered: Date[] = value.sort(function (a, b) {
        return new Date(a).getTime() - new Date(b).getTime();
      });

      value = valuesDatesOrdered.map(val => new Date(val).toLocaleString());
    }

    return value.join(', ');
  }
  private formatValue(value: string): string {
    if (this.isFormatIsoDate(value)) {
      return new Date(value).toLocaleString();
    }
    return value;
  }
  private isFormatIsoDate(value: string) {
    return this.isISOFormat(value) && !isNaN(Date.parse(value));
  }
  private isISOFormat(value: string): boolean {
    return !!value && value.length == 24 && this.isISOTagsFormats(value);
  }
  private isISOTagsFormats(value: string): boolean {
    return (value.substr(4, 1) == '-' && value.substr(7, 1) == '-'
      && value.substr(10, 1) == 'T' && value.substr(13, 1) == ':'
      && value.substr(16, 1) == ':' && value.substr(19, 1) == '.'
      && value.substr(23, 1) == 'Z');
  }

  private getTablaMateriales(materiales: SolicitudMaterial[]): TableInfo {
    const table: TableInfo = new TableInfo();

    table.columns = [
      { name: 'Name', prop: 'NOMBRE_MATERIAL' },
      { name: 'Quantity', prop: 'CANTIDAD' }
    ];
    table.rows = materiales;

    table.page.totalElements = materiales.length;

    return table;
  }

  toggleExpandRow(row, table: any) {
    event.stopPropagation();
    table.rowDetail.toggleExpandRow(row);
  }

  onResized(event: ResizedEvent, table: any): void {
    if (table) {
      setTimeout(() => {
        table.recalculate();
        window.dispatchEvent(new Event('resize'));
      }, (50));
    }
  }

  onActivateNormalTable(event) {
    if (event.type == 'click' && event.event.target.className.indexOf('isButton') == -1) {
      if (!this.isDevoluciones) {
        this.deselectElementsTables();
        this.normalTable.singleSelected = [event.row];
        this.selectEvent.emit(event.row);
      } else {
        this.manageRowsDevolucionesSelected(this.normalTable.singleSelected, event.row);
      }
    }
  }
  private manageRowsDevolucionesSelected(singleSelected: TableContentInfo[], row: TableContentInfo) {
    if (this.hasBeenSelected(singleSelected, row.contenidoId)) {
      this.rowsDevolucionesSelected.push(row);
    } else {
      this.rowsDevolucionesSelected = this.rowsDevolucionesSelected.filter(rowSelected => rowSelected.contenidoId != row.contenidoId);
    }
    this.rowsDevolucionesSelectedChange.emit(this.rowsDevolucionesSelected);
  }

  private hasBeenSelected(selectedList: TableContentInfo[], contentId: number) {
    return selectedList.some(elementSelected => elementSelected.contenidoId == contentId);
  }

  private deselectElementsTables(): any {
    if (this.normalTable) {
      this.normalTable.singleSelected = [];
    }
    if (this.recordTable) {
      this.recordTable.singleSelected = [];
    }
    if (this.containerTable) {
      this.containerTable.singleSelected = [];
    }
    if (this.azTable) {
      this.azTable.singleSelected = [];
    }
  }

  onActivateContainerTable(event) {
    if (event.type == 'click' && event.event.target.className.indexOf('isButton') == -1) {
      if (!this.isDevoluciones) {
        this.deselectElementsTables();
        this.containerTable.singleSelected = [event.row];
        this.selectEvent.emit(event.row);
      } else {
        this.manageRowsDevolucionesSelected(this.containerTable.singleSelected, event.row);
      }
    }
  }

  onActivateRecordTable(event) {
    if (event.type == 'click' && event.event.target.className.indexOf('isButton') == -1) {
      if (!this.isDevoluciones) {
        this.deselectElementsTables();
        this.recordTable.singleSelected = [event.row];
        this.selectEvent.emit(event.row);
      } else {
        this.manageRowsDevolucionesSelected(this.recordTable.singleSelected, event.row);
      }
    }
  }

  onActivateAzTable(event) {
    if (event.type == 'click' && event.event.target.className.indexOf('isButton') == -1) {
      if (!this.isDevoluciones) {
        this.deselectElementsTables();
        this.azTable.singleSelected = [event.row];
        this.selectEvent.emit(event.row);
      } else {
        this.manageRowsDevolucionesSelected(this.azTable.singleSelected, event.row);
      }
    }
  }

  getRowClass = (row) => {
    return {
      'ngx-row-selected': row.contenidoId && row.contenidoId == this.contenidoSeleccionado
    };
  }

  goToRelationRequest(solicitudRelacionada: number, contenidoRelacionado: number) {

    this.router.navigate(['docout', {
      outlets: {
        contenido: ['detalle', solicitudRelacionada, {
          contenidoSeleccionado: contenidoRelacionado
        }]
      }
    }]);
  }

  chargeInventoryRecord(idExpediente) {
    this.inventoryService.goToRecordDetailById(idExpediente);
  }

  chargeInventoryContainer(idContenedor) {
    this.inventoryService.goToContainers(idContenedor);
  }

  goToAz(idAz) {
    this.inventoryService.goToAz(idAz);
  }

  showModalText(obsPartial) {
    const modalTitle = 'inventory.obsPartial';
    const modalTextConfirm = 'generales.ok';
    const disabled = true;
    const showCloseButton = false;
    const modal = this.modalService.show(ModalShowTextComponent);
    (<ModalShowTextComponent>modal.content).showTextModal(
      modalTitle,
      obsPartial,
      modalTextConfirm,
      disabled,
      showCloseButton
    );
  }

  private setDateInTableInfo(table: TableInfo, date: Date, nameProperty: string): any {
    if (table) {
      const dateString = this.getDateToString(date);
      for (const row of table.rows) {
        if (row.constructor.name === 'TableContentInfo') {
          row[nameProperty] = dateString;
        }
      }
    }
  }
  private getDateToString(date: Date): string {
    const day = ('0' + date.getDate()).slice(-2);
    const month = ('0' + (date.getMonth() + 1)).slice(-2);
    const hours = ('0' + date.getHours()).slice(-2);
    const minutes = ('0' + date.getMinutes()).slice(-2);
    const seconds = ('0' + date.getSeconds()).slice(-2);
    return date.getFullYear() + '-' + month + '-' + day + 'T' + hours + ':' + minutes + ':' + seconds;
  }

  isRecordMultivalue(record) {
    return record instanceof Array;
  }

  searchFiltroNormalContent(filtros: TemplateField[]) {
    this.normalTable.page.pageNumber = 0;
    this.isNormalTableSearch = true;
    this.isNormalTableFiltered = true;
    this.filtroNormalContent.FiltroCampos = filtros.map((campo: TemplateField) => campo.toDTO());
    this.requestNormalContent();
  }

  searchFiltroContainerContent(filtros: CampoSolicitud[]) {
    this.containerTable.page.pageNumber = 0;
    this.isContainerTableFiltered = true;
    const campos: TemplateField[] = this.convertCamposSolicitudEnTemplateField(filtros);
    this.filtroContenedoresContent.FiltroCampos = campos.map((campo: TemplateField) => campo.toDTO());
    this.filtroContenedoresContent.TotalElementsInventory = this.recordTable.page.size;
    this.requestContenedoresContent();
  }

  searchFiltroRecordContent(filtros: CampoSolicitud[]) {
    this.recordTable.page.pageNumber = 0;
    this.isRecordTableFiltered = true;
    const campos: any[] = (filtros instanceof Array && filtros[0] instanceof CampoSolicitud)
      ? this.convertCamposSolicitudEnTemplateField(filtros)
      : filtros;

    this.filtroExpedienteContent.FiltroCampos = campos.map((campo: TemplateField) => campo.toDTO());
    this.filtroExpedienteContent.TotalElementsInventory = this.recordTable.page.size;
    this.requestExpedientesContent();
  }

  searchFiltroAzContent(filtros: CampoSolicitud[]) {
    this.azTable.page.pageNumber = 0;
    this.isAzTableFiltered = true;
    const campos: TemplateField[] = this.convertCamposSolicitudEnTemplateField(filtros);
    this.filtroAZContent.FiltroCampos = campos.map((campo: TemplateField) => campo.toDTO());
    this.filtroAZContent.TotalElementsInventory = this.recordTable.page.size;
    this.requestAzsContent();
  }


  private convertCamposSolicitudEnTemplateField(filtros: CampoSolicitud[]): TemplateField[] {
    return filtros.map(filtro => {
      return filtro.toTemplateField();
    });
  }

  getContents() {
    if (this.hasBasicData() && !this.hasRequestedInitialData) {
      this.hasRequestedInitialData = true;
      if (!this.isMaterialRequest) {
        this.getContentsByType();
      } else {
        this.getMaterials();
      }
    }
  }

  private getMaterials() {
    this.detalleservice.getRequestedMaterials(this.solicitudId)
      .subscribe((materiales: SolicitudMaterial[]) => {
        if (materiales) {
          this.normalTable = this.getTablaMateriales(materiales);
        } else {
          this.normalTable = new TableInfo();
        }
        this.hasMaterials = true;
        this.finishContenidosNoInventory(this.normalTable.rows as TableContentInfo[]);
      });
  }

  private getContentsByType() {

    const filtro = new FiltrosContenidos();
    filtro.IdSerie = this.idSerie;
    filtro.NombreTipoServicio = this.nombreTipoServicio;
    filtro.FiltroContenidos = this.filtroDevolucion;
    filtro.IsDevolucionSolicitud = !!this.idSolicitudDevolucion;

    if (this.contador.NUM_CONTENIDOS_NO_INVENTARIO > 0) {
      this.filtroNormalContent = { ...filtro };
      this.requestNormalContent();
    } else {
      this.finishContenidosNoInventory([new TableContentInfo()]);
    }
    if (this.contador.NUM_CONTENIDOS_EXPEDIENTES > 0) {
      this.filtroExpedienteContent = { ...filtro };
      this.requestExpedientesContent();
    } else {
      this.finishContenidosExpedientes([new TableContentInfo()]);
    }
    if (this.contador.NUM_CONTENIDOS_CONTENEDORES > 0) {
      this.filtroContenedoresContent = { ...filtro };
      this.requestContenedoresContent();
    } else {
      this.finishContenidosContenedores([new TableContentInfo()]);
    }
    if (this.contador.NUM_CONTENIDOS_AZ > 0) {
      this.filtroAZContent = { ...filtro };
      this.requestAzsContent();
    } else {
      this.finishContenidosAz([new TableContentInfo()]);
    }
    this.totalContentCounter = this.contador.NUM_CONTENIDOS_NO_INVENTARIO +
      this.contador.NUM_CONTENIDOS_EXPEDIENTES +
      this.contador.NUM_CONTENIDOS_CONTENEDORES +
      this.contador.NUM_CONTENIDOS_AZ;
  }
  private requestNormalContent(): any {
    let inicio = 0, fin = 10;
    if (this.normalTable) {
      inicio = this.normalTable.page.size * this.normalTable.page.pageNumber;
      if (inicio != 0 && inicio >= this.normalTable.page.totalElements) {
        inicio = inicio - this.normalTable.page.size;
      }

      fin = inicio + (+this.normalTable.page.size);
    }

    this.resetRowsSelected();

    this.getMethodNoInventory(inicio, fin)
      .subscribe((contenidosNoInventory: IPagination<ContenidoSolicitud>) => {
        this.normalTable = this.getNormalDatatableContent(contenidosNoInventory, this.normalTable);
        this.normalTable.singleSelected = this.manageSelectedRowsInTable(this.normalTable.rows as TableContentInfo[]);
        this.finishContenidosNoInventory(this.normalTable.rows as TableContentInfo[]);
      },
        errorCode => {
          this.toastr.error('Error cargando los datos de la solicitud');
        });
  }
  private manageSelectedRowsInTable(rows: TableContentInfo[]): TableContentInfo[] {
    return rows.filter((row: TableContentInfo) =>
      this.rowsDevolucionesSelected.some(rowSelected => rowSelected.contenidoId == row.contenidoId));
  }

  private getMethodNoInventory(inicio: number, fin: number) {
    return this.isPeticionSolicitud() ?
      this.detalleservice.getContentNoInventory(this.solicitudId || this.idSolicitudDevolucion, this.filtroNormalContent, inicio, fin).pipe(first())
      : this.detalleservice.getDevolucionesNoInventory(this.filtroNormalContent, inicio, fin).pipe(first());
  }

  private isPeticionSolicitud() {
    return !this.hasAllDataDevoluciones() || this.idSolicitudDevolucion;
  }

  getExportDataNoInventory() {
    this.getMethodNoInventory(0, this.contador.NUM_CONTENIDOS_NO_INVENTARIO)
      .subscribe(data => {
        this.normalTableDatasToExport = this.getTableRows(data.dataList);
      },
        errorCode => {
          this.toastr.error('Error cargando los datos de la solicitud');
        });
  }

  private requestContenedoresContent(): any {
    let inicio = 0, fin = 10;
    if (this.containerTable) {
      inicio = this.containerTable.page.size * this.containerTable.page.pageNumber;
      if (inicio != 0 && inicio >= this.containerTable.page.totalElements) {
        inicio = inicio - this.containerTable.page.size;
      }

      fin = inicio + (+this.containerTable.page.size);
    }

    this.resetRowsSelected();

    this.getMethodContainers(inicio, fin)
      .subscribe((contenidosContenedores: IPagination<ContenidoSolicitud>) => {
        this.filtroContenedoresContent.TotalElementsInventory = contenidosContenedores.totalResults;
        this.containerTable = this.getContainerDatatableContent(contenidosContenedores, this.containerTable);
        this.finishContenidosContenedores(this.containerTable.rows as TableContentInfo[]);
      });
  }

  private getMethodContainers(inicio: number, fin: number) {
    return this.isPeticionSolicitud() ?
      this.detalleservice.getContentContainer(this.solicitudId || this.idSolicitudDevolucion, this.filtroContenedoresContent, inicio, fin).pipe(first())
      : this.detalleservice.getDevolucionesContainer(this.filtroContenedoresContent, inicio, fin).pipe(first());
  }

  getExportDataContainer() {
    this.getMethodContainers(0, this.contador.NUM_CONTENIDOS_CONTENEDORES)
      .subscribe(data => {
        this.containerTableDatasToExport = this.getTableRows(data.dataList);
      });
  }

  private requestExpedientesContent(): any {
    let inicio = 0, fin = 10;
    if (this.recordTable) {
      inicio = this.recordTable.page.size * this.recordTable.page.pageNumber;
      if (inicio != 0 && inicio >= this.recordTable.page.totalElements) {
        inicio = inicio - this.recordTable.page.size;
      }

      fin = inicio + (+this.recordTable.page.size);
    }

    this.resetRowsSelected();

    this.getMethodRecords(inicio, fin)
      .subscribe((contenidosExpedientes: IPagination<ContenidoSolicitud>) => {
        this.filtroExpedienteContent.TotalElementsInventory = contenidosExpedientes.totalResults;
        this.recordTable = this.getRecordDatatableContent(contenidosExpedientes);
        this.finishContenidosExpedientes(this.recordTable.rows as TableContentInfo[]);
      });
  }

  getExportDataRecord() {
    this.getMethodRecords(0, this.contador.NUM_CONTENIDOS_EXPEDIENTES)
      .subscribe(data => {
        this.recordTableDatasToExport = this.getTableRows(data.dataList);
      });
  }

  private getMethodRecords(inicio: number, fin: number) {
    return this.isPeticionSolicitud() ?
      this.detalleservice.getContentRecord(this.solicitudId || this.idSolicitudDevolucion, this.filtroExpedienteContent, inicio, fin).pipe(first())
      : this.detalleservice.getDevolucionesRecord(this.filtroExpedienteContent, inicio, fin).pipe(first());
  }

  private requestAzsContent(): any {
    let inicio = 0, fin = 10;
    if (this.azTable) {
      inicio = this.azTable.page.size * this.azTable.page.pageNumber;
      fin = inicio + this.azTable.page.size;
    }

    this.resetRowsSelected();

    this.getMethodAzs(inicio, fin)
      .subscribe((contenidosAz: IPagination<ContenidoSolicitud>) => {
        this.filtroAZContent.TotalElementsInventory = contenidosAz.totalResults;
        this.azTable = this.getAzDatatableContent(contenidosAz);
        this.finishContenidosAz(this.azTable.rows as TableContentInfo[]);
      });
  }

  getExportDataAz() {
    this.getMethodAzs(0, this.contador.NUM_CONTENIDOS_AZ)
      .subscribe(data => {
        this.azTableDatasToExport = this.getTableRows(data.dataList);
      });
  }

  private getMethodAzs(inicio: number, fin: number) {
    return this.isPeticionSolicitud() ?
      this.detalleservice.getContentAZ(this.solicitudId || this.idSolicitudDevolucion, this.filtroAZContent, inicio, fin).pipe(first())
      : this.detalleservice.getDevolucionesAZ(this.filtroAZContent, inicio, fin).pipe(first());
  }


  private finishContenidosNoInventory(rows: TableContentInfo[]): any {
    this.hasNoInventoryData = true;
    this.setContenidosNoInventariados.emit(rows);
    const rowSelected = this.totalContentCounter == 1 && !this.isDevoluciones && !this.isMaterialRequest
      ? rows[0] : null;
    this.checkFinishRequestContents(rowSelected);
  }
  private finishContenidosExpedientes(rows: TableContentInfo[]): any {
    this.hasRecordData = true;
    this.setContenidosExpedientes.emit(rows);
    const rowSelected = this.totalContentCounter == 1 && !this.isDevoluciones && !this.isMaterialRequest
      ? rows[0] : null;
    this.checkFinishRequestContents(rowSelected);
  }
  private finishContenidosContenedores(rows: TableContentInfo[]): any {
    this.hasContainerData = true;
    this.setContenidosContenedores.emit(rows);
    const rowSelected = this.totalContentCounter == 1 && !this.isDevoluciones && !this.isMaterialRequest
      ? rows[0] : null;
    this.checkFinishRequestContents(rowSelected);
  }
  private finishContenidosAz(rows: TableContentInfo[]): any {
    this.hasAzData = true;
    this.setContenidosAZs.emit(rows);
    const rowSelected = this.totalContentCounter == 1 && !this.isDevoluciones && !this.isMaterialRequest
      ? rows[0] : null;
    this.checkFinishRequestContents(rowSelected);
  }

  private checkFinishRequestContents(rowSelected: TableContentInfo) {
    if ((this.hasNoInventoryData && this.hasRecordData && this.hasContainerData && this.hasAzData) || this.hasMaterials) {
      this.hasMoreThanOneTable = this.thereAreMoreOneTable();
      this.hasMoreThanOneTableEvent.emit(this.hasMoreThanOneTable);
      this.hasData = this.hasAnyData();
      this.hasAllData.emit(true);
      this.isNormalTableChangingPage = false;
      this.isNormalTableFiltered = false;
      this.isContainerTableChangingPage = false;
      this.isContainerTableFiltered = false;
      this.isRecordTableFiltered = false;
      this.isRecordTableChangingPage = false;
      this.isAzTableChangingPage = false;
      if (rowSelected) {
        const tableActive = this.normalTable || this.recordTable || this.containerTable || this.azTable;
        tableActive.singleSelected = [rowSelected];
        this.selectEvent.emit(rowSelected);
      }
    } else {
      this.hasAllData.emit(false);
    }
  }

  private hasAnyData(): boolean {
    return !!(this.normalTable || this.recordTable || this.containerTable || this.azTable);
  }

  private hasBasicData() {
    const hasAllDataRequestDetails = !!this.solicitudId && !!this.contador
      && !!this.idSerie && !!this.nombreTipoServicio;
    const hasAllDataMaterials = !!this.solicitudId && !!this.contador
      && this.isMaterialRequest;
    const hasAllDataDevoluciones = this.hasAllDataDevoluciones() && !this.idSolicitudDevolucion;
    const hasAllDataSolicitudDevoluciones = this.hasAllDataDevoluciones() && !!this.idSolicitudDevolucion;
    return hasAllDataRequestDetails || hasAllDataMaterials || hasAllDataDevoluciones || hasAllDataSolicitudDevoluciones;
  }

  private hasAllDataDevoluciones(): boolean {
    return !!this.contador && !!this.idSerie && this.isDevoluciones && !!this.nombreTipoServicio;
  }

  getNormalContentsOnChangeSize() {
    this.isNormalTableChangingPage = true;
    this.normalTable.page.pageNumber = 0;
    this.tablaNormalElementRef.recalculate();
    this.requestNormalContent();
  }

  getContainerContentsOnChangeSize() {
    this.isContainerTableChangingPage = true;
    this.containerTable.page.pageNumber = 0;
    this.tablaContainerElementRef.recalculate();
    this.requestContenedoresContent();
  }

  getRecordContentsOnChangeSize() {
    this.isRecordTableChangingPage = true;
    this.recordTable.page.pageNumber = 0;
    this.tablaRecordElementRef.recalculate();
    this.requestExpedientesContent();
  }

  getAzContentsOnChangeSize() {
    this.isAzTableChangingPage = true;
    this.azTable.page.pageNumber = 0;
    this.tablaAzElementRef.recalculate();
    this.requestAzsContent();
  }


  setNormalTablePage(pageInfo: any) {
    this.isNormalTableChangingPage = true;
    this.normalTable.page.pageNumber = pageInfo.offset;
    this.requestNormalContent();
  }
  setContainerTablePage(pageInfo: any) {
    this.isContainerTableChangingPage = true;
    this.containerTable.page.pageNumber = pageInfo.offset;
    this.requestContenedoresContent();
  }

  setRecordTablePage(pageInfo: any) {
    this.isRecordTableChangingPage = true;
    this.recordTable.page.pageNumber = pageInfo.offset;
    this.requestExpedientesContent();
  }

  setAzTablePage(pageInfo: any) {
    this.isAzTableChangingPage = true;
    this.azTable.page.pageNumber = pageInfo.offset;
    this.requestAzsContent();
  }

  resetRowsSelected() {
    if (!this.isDevoluciones) {
      if (this.normalTable) {
        this.normalTable.singleSelected = [];
      }
      if (this.containerTable) {
        this.containerTable.singleSelected = [];
      }
      if (this.recordTable) {
        this.recordTable.singleSelected = [];
      }
      if (this.azTable) {
        this.azTable.singleSelected = [];
      }

      this.resetRowSelect.emit(true);
    }
  }

  getContentProperty(contenido: TableContentInfo, property: string) {
    return contenido.campos[property];
  }

  getExportData(column: any, data: TableContentInfo): string {
    if (column.isDynamic) {
      return data.campos[column.prop];
    }
    return data[column.prop];
  }


}
